"use client";

import { useEffect } from "react";
import { useCookieConsent } from "src/lib/CookieConsent";
import { updateGoogleAnalytics } from "src/lib/GoogleAnalytics";
import { usePathname } from "src/lib/Navigation";

export default function GoogleAnalytics() {
  const { analyticsAllowed, marketingAllowed } = useCookieConsent();
  const pathname = usePathname();
  useEffect(
    () => updateGoogleAnalytics(analyticsAllowed, pathname, undefined, marketingAllowed),
    [analyticsAllowed, marketingAllowed, pathname],
  );
  return null;
}
